'use client'
import React, { useState } from 'react'
import parse from 'html-react-parser';
import tailwindConfig from '@tailwind.config'


const BlogComponent = ({ html }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };
    const style2 = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 120,
        overflow: 'hidden',
        z: 10
    };

    const maxContentLength = 200; // Maximum characters to display before truncating
    const [showFullContent, setShowFullContent] = useState(false);

    const truncatedContent = html.slice(0, maxContentLength);
    const isContentTruncated = html.length > maxContentLength;

    const toggleContent = () => {
        setShowFullContent(!showFullContent);
    };

    return (
        <div className='mb-2 pb-2'>
            <div /*className='text-justify'*/>
                {!showFullContent && (
                    <>
                        <div style={style2} className='text-xl [&_a]:underline [&_a]:underline-offset-4 [&_a]:text-maincolor [&_a:hover]:opacity-70'>
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='relative w-full flex flex-row-reverse'>
                                <div className='absolute right-0 left-0 top-[-20px] h-[20px] bg-gradient-to-b from-transparent to-light'></div>
                                <button
                                    className="text-third mt-2 cursor-pointer border-[1px] border-maincolor bg-maincolor rounded-md px-1 hover:bg-third hover:text-maincolor"
                                    onClick={toggleContent}
                                >
                                    {showFullContent ? 'Read Less' : 'Read More'}
                                </button>
                            </div>
                        )}
                    </>
                )}
                {showFullContent && (
                    <>
                        <div style={style} className='text-xl [&_a]:underline [&_a]:underline-offset-4 [&_a]:text-maincolor [&_a:hover]:opacity-70'>
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='w-full flex flex-row-reverse'>
                                {/* <br /> */}
                                <button
                                    className="text-third mt-2 cursor-pointer border-[1px] border-maincolor bg-maincolor rounded-md px-1 hover:bg-third hover:text-maincolor z-40"
                                    onClick={toggleContent}
                                >
                                    {showFullContent ? 'Read Less' : 'Read More'}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default BlogComponent